import {DomainObject, oneOf} from 'shared/store';
import { observable, makeObservable } from 'mobx';
import {Employee} from 'main/stores/employees';

class PayrollUpdate extends DomainObject {
  id;
  action;
  employee;
  createdAt;
  changes;
  status;

  _relations = {
    employee: Employee,
    action: oneOf(['employee_onboarded', 'employee_updated', 'employee_terminated', 'employee_reactivated']),
    status: oneOf(['submitted', 'completed'])
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      action: observable,
      employee: observable,
      createdAt: observable,
      changes: observable,
      status: observable
    });

    this.merge(other);
  }
}

export default PayrollUpdate;
